export const INSURANCE_PAYER_TYPE = 'insurance'
export const EMPLOYER_PAYER_TYPE = 'employer'
